export enum enumLclTrackingStates {
  BOOKING_PLACED,
  AT_ORIGIN_WAREHOUSE,
  IN_TRANSIT,
  AT_DESTINATION_WAREHOUSE,
  DELIVERED,
}
